import { render, staticRenderFns } from "./cuservice.vue?vue&type=template&id=60d5e9c2&scoped=true"
var script = {}
import style0 from "./cuservice.vue?vue&type=style&index=0&id=60d5e9c2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5e9c2",
  null
  
)

export default component.exports